export default __webpack_public_path__ + "static/media/closet2-2048w.35437e38.avif";